// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9acc3968","239":"c7664a5e","453":"06ada9b0","732":"901eb19f"}[chunkId] + ".chunk.js";
};